import styled from 'styled-components';

export const Container = styled.button`
  float: left;
  background: none;
  display: flex;
  font-size: 1rem;
  margin: 0 1rem;
  color: ${({ theme }) => theme.colors.FORM_CANCEL_TEXT};
  cursor: pointer;
  transition: all 0.5s ease;

  &:hover {
    opacity: 0.5;
    text-decoration: underline;
  }


  @media (max-width: 1024px) {
    font-size: 0.8rem;
  }
`;
